import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';

const OutageBanner = () => import(/* webpackChunkName: "4-feat-browser-deprecation-message" */ './OutageBanner');

export default lazyLoadOnRender({ loader: OutageBanner });
